import { createSlice } from '@reduxjs/toolkit'

export const musicSlice = createSlice({
  name: 'music',
  initialState: {
    title: 'Breaking Bad',
    description: 'Music intro from the best series ever',
    files: [],
    addBtnShow: false,
    btnUrl: 'https://example.com',
    btnText: 'Buy now',
    titleFont: 'Arial',
    titleColor: '#000000',
    descriptionColor: '#000000',
    cardBackgroundColor: '#ffffff',
    btnTextColor: '#ffffff',
    btnBackgroundColor: '#007bff'
  },
  reducers: {
    setMusicField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setLogoFile(state, action) {
      state.files[0] = action.payload
    },
    setMusicFile(state, action) {
      state.files[1] = action.payload
    },
    setAddBtnShow(state, action) {
      state.addBtnShow = action.payload
    },
    initializeMusic(state, action) {
      state.title = 'Breaking Bad'
      state.description = 'Music intro from the best series ever'
      state.files = []
      state.addBtnShow = false
      state.btnUrl = 'https://example.com'
      state.btnText = 'Buy now'
      state.titleFont = 'Arial'
      state.titleColor = '#000000'
      state.descriptionColor = '#000000'
      state.cardBackgroundColor = '#ffffff'
      state.btnTextColor = '#ffffff'
      state.btnBackgroundColor = '#007bff'
    }
  }
})

export const {
  setMusicField,
  setLogoFile,
  setMusicFile,
  setAddBtnShow,
  initializeMusic
} = musicSlice.actions
export default musicSlice.reducer